import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import {YES_NO_OPTIONS} from "../../constants/general-constants";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';

import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_HIDDEN} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECT_WITH_CHANGE_FUNCTION} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDB} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDBCONCATENATION} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {STRINGIFY} from "../../constants/general-constants";
import {SYSTEM_ROLE_SUPERADMIN} from "../../constants/general-constants";
import {NO_STRINGIFY} from "../../constants/general-constants";
import EditPanelInputSelectFromDb from '../administration/components/EditPanelInputSelectFromDb';
import EditPanelInputText from '../administration/components/EditPanelInputText';
import EditButtonPanel from '../administration/components/EditButtonPanel';
import AdminFloors from '../administration/components/AdminFloors';
import CircularProgress from '@material-ui/core/CircularProgress';
import {DEFAULT_BLUE} from "../../constants/general-constants";

import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";


export default function AdministrationPropertiesEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [entityCode, setEntityCode] = useState("");
	const [entityName, setEntityName] = useState("New Property");
	const [entityDescription, setEntityDescription] = useState("");
	const [classifications, setClassifications] = useState([]);
	const [photoName, setPhotoName] = useState("");
	const [photoSource, setPhotoSource] = useState("");
	const [planName, setPlanName] = useState("");
	const [planSource, setPlanSource] = useState("");
	const [scanId, setScanId] = useState("-100");
	const [isSite, setIsSite] = useState(false);
	const [mainComponentRows, setMainComponentRows] = useState([]);
	
	const [displayProgress, setDisplayProgress] = useState("none");
	const [displayUploadPopup, setDisplayUploadPopup] = useState("none");
	const [isModel, setIsModel] = useState(0);
	
	const uploadFileInput = useRef(null);
	const uploadFileModelCheck = useRef(null);
	
	const refCode = useRef(null);
	const refName = useRef(null);
	const refSelect = useRef(null);
	const refDescription = useRef(null);
	const refSingleBuilding = useRef(null);	
	const refParentId = useRef(null);
	const refFacilityId = useRef(null);
	const refArea = useRef(null);
	const refLat = useRef(null);
	const refLng = useRef(null);
	const refSvg = useRef(null);
	const refSvgImageDimensions = useRef(null);
	const refClassifications = useRef(new Array());
	const refAtisUrl = useRef(null);
	const refPhoto = useRef(null);
	const refPlan = useRef(null);
	
	const id = useParams()["id"];
	
	useEffect(() => {
		loadClassifications();
		loadData();
		if(isSuperAdmin() === true){
			setMainComponentRows(
				[
					{ref:refCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
					{ref:refName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
					{ref:refDescription, id:"3", title:"Description", inputType:INPUT_TYPE_TEXTAREA},
					{ref:refSingleBuilding, id:"5", title:"Is Single Building?", inputType:INPUT_TYPE_SELECT_WITH_CHANGE_FUNCTION, options:YES_NO_OPTIONS, changeFunction:handleSingleBuildingChange},
					{ref:refParentId, id:"6", title:"Location", inputType:INPUT_TYPE_SELECTFROMDBCONCATENATION, restUrl:"voyansiadmingetconcatenationgeographies"},
					{ref:refFacilityId, id:"7", title:"Parent Property", inputType:INPUT_TYPE_SELECTFROMDB, restUrl:"facilities"},
					{ref:refArea, id:"8", title:"Area (Sq Ft)", inputType:INPUT_TYPE_TEXT},
					{ref:refLat, id:"9", title:"GPS Latitude", inputType:INPUT_TYPE_TEXT},
					{ref:refLng, id:"10", title:"GPS Longitude", inputType:INPUT_TYPE_TEXT},
					{ref:refSvg, id:"11", title:"SVG (Hotspot)", inputType:INPUT_TYPE_TEXTAREA},
					{ref:refSvgImageDimensions, id:"12", title:"SVG Image Dimensions", inputType:INPUT_TYPE_TEXT}
				]
			);
		}
		else{
			setMainComponentRows(
				[
					{ref:refCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
					{ref:refName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
					{ref:refDescription, id:"3", title:"Description", inputType:INPUT_TYPE_TEXTAREA},
					{ref:refSingleBuilding, id:"5", title:"Is Single Building?", inputType:INPUT_TYPE_HIDDEN, options:YES_NO_OPTIONS, changeFunction:handleSingleBuildingChange},
					{ref:refParentId, id:"6", title:"Location", inputType:INPUT_TYPE_SELECTFROMDBCONCATENATION, restUrl:"voyansiadmingetconcatenationgeographies"},
					{ref:refFacilityId, id:"7", title:"Parent Property", inputType:INPUT_TYPE_HIDDEN, restUrl:"facilities"},
					{ref:refArea, id:"8", title:"Area (Sq Ft)", inputType:INPUT_TYPE_TEXT},
					{ref:refLat, id:"9", title:"GPS Latitude", inputType:INPUT_TYPE_TEXT},
					{ref:refLng, id:"10", title:"GPS Longitude", inputType:INPUT_TYPE_TEXT},
					{ref:refSvg, id:"11", title:"SVG (Hotspot)", inputType:INPUT_TYPE_HIDDEN},
					{ref:refSvgImageDimensions, id:"12", title:"SVG Image Dimensions", inputType:INPUT_TYPE_HIDDEN}
				]
			);
		}
	}, [id]);
	
	useEffect(() => {
		if(classifications.length > 0){
			functions.getArrayFromAjax("/resolution/classificationvaluesforentity?entityId=" + id + "&entityType=2", null, initialiseClassifications);
		}
	}, [classifications]);
	
	const isSuperAdmin = () => {
		let returnVal = false;
		if(globalState.state.loggedIn.roles.includes(SYSTEM_ROLE_SUPERADMIN)){	
			returnVal = true;	
		}
		
		return returnVal;
	};
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const loadData = () => {
		const timer = setTimeout(() => {
			functions.getObjectFromAjax("/resolution/facility?id=" + id, null, initialiseFields);
			functions.getObjectFromAjax("/resolution/facilityscansforfacility?facilityId=" + id, null, initialiseScan);
		}, 2000);
	};
	
	const loadClassifications = () => {
			functions.getArrayFromAjax("/resolution/getpropertyclassifications", setClassifications, null);
			
	};
	
	const initialiseFields = (entity) => {
		try{
			setEntityCode(entity.code);
			setEntityName(entity.name);
			setEntityDescription(entity.description);
			refCode.current.value = entity.code;
			refName.current.value = entity.name;
			refDescription.current.value = entity.description;
			try{
				if(entity.singleBuilding === true){
					refSingleBuilding.current.value = "Y";
				}
				else{
					refSingleBuilding.current.value = "N";
				}
				refFacilityId.current.value = entity.facilityId;
				refSvg.current.value = entity.svg;
				refSvgImageDimensions.current.value = entity.svgImageDimensions;
			}
			catch(e){}
			refParentId.current.value = entity.parentId;
			
			refArea.current.value = entity.areaReportable;
			refLat.current.value = entity.lat;
			refLng.current.value = entity.lng;
			
			setPhotoName(entity.photoFile);
			setPlanName(entity.planFile);
			try{
				let initialPhoto = globalState.state.client.resourceFolderUrl + "/buildingphotos/" + entity.code + "/" + entity.photoFile;
				functions.getFileSource(initialPhoto,
					setPhotoSource, null);
			}
			catch(e){}	
			try{
				let initialPlan = globalState.state.client.resourceFolderUrl + "/buildingphotos/" + entity.code + "/" + entity.planFile;
				functions.getFileSource(initialPlan,
					setPlanSource, null);
			}
			catch(e){}	
		}
		catch(e){}
		
	};
	
	const initialiseScan = (scan) => {
			setScanId(scan.id);
			refAtisUrl.current.value = scan.atisUrl
	};
	
	
	const initialiseClassifications = (results) => {
		for(let i=0; i<results.length; i++){
			let classificationId = results[i].classificationId;
			let classificationItemId = results[i].classificationItemId;
			for(let j=0; j<classifications.length; j++){
				if(classifications[j].id === classificationId){
					const timer = setTimeout(() => {
						refClassifications.current[j].value = classificationItemId;
					}, 2000);
				}
			}
		}
	};
	
	const handleSingleBuildingChange = () => {
		if(refSingleBuilding.current.value === "Y"){
			setIsSite(false);
		}
		else{
			setIsSite(true);
		}
	};

	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"20px",
		alignItems:"center",
		color:"black",
		justifyContent:"space-between"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	
	
	
	const getSubmitObject = () => {
		try{
			let tempSingleBuilding = false;
			if(refSingleBuilding.current.value === "Y"){
				tempSingleBuilding = true;
			}
			let submitObject = {
				id:id,
				parentId:refParentId.current.value,
				facilityId:refFacilityId.current.value,
				code:refCode.current.value,
				name:refName.current.value,
				description:refDescription.current.value,
				svgImageDimensions:refSvgImageDimensions.current.value,
				svg:refSvg.current.value,
				lat:refLat.current.value,
				lng:refLng.current.value,
				areaReportable:parseFloat(refArea.current.value),
				singleBuilding:tempSingleBuilding,
				capacity:0,
				areaNia:0,
				areaGia:0,
				areaLeased:0,
				annualCost:0,
				costPerAreaCurrencyId:-100,
				unitAreaId:-100,
				archived:false,
				photoFile:photoName,
				planFile:planName
			};
		
			return submitObject
		}
		catch(e){
			
			let submitObject = {
				id:id,
				parentId:refParentId.current.value,
				facilityId:-100,
				code:refCode.current.value,
				name:refName.current.value,
				description:refDescription.current.value,
				svgImageDimensions:'',
				svg:'',
				lat:refLat.current.value,
				lng:refLng.current.value,
				areaReportable:parseFloat(refArea.current.value),
				singleBuilding:true,
				capacity:0,
				areaNia:0,
				areaGia:0,
				areaLeased:0,
				annualCost:0,
				costPerAreaCurrencyId:-100,
				unitAreaId:-100,
				archived:false,
				photoFile:photoName,
				planFile:planName
			};
		
		return submitObject
		}
		
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/facilitysave", 
				getSubmitObject(), submitClassifications,  STRINGIFY, handleSubmitError);
		
	};
	
	const submitClassifications = () => {
		
		let classificationValues = [];
		
		for(let i=0; i<classifications.length; i++){
			classificationValues.push({
				id:-100,
				classificationId:classifications[i].id,
				classificationItemId:refClassifications.current[i].value,
				linkId:id,
				linkType:2,
				superParentClassificationId:classifications[i].id
			});
		}
		
		functions.submitAjaxWithId("/resolution/propertyclassificationvaluesave", 
				classificationValues, saveScanInfo, STRINGIFY, handleSubmitError, id);
		
	};
	
	const saveScanInfo = () => {
		
		let facilityScan = {
			id:scanId,
			facilityId:id,
			matterportScanId:'',
			truviewScanId:'',
			atisUrl:refAtisUrl.current.value,
			rvtFile:'',
			cintooId:'',
			giraffeId:''
		};
		
		functions.submitAjax("/resolution/facilityscansave", 
				facilityScan, submitPhoto,  STRINGIFY, handleSubmitError);
	};
	
	const submitPhoto = () => {
		if(refPhoto.current.files && refPhoto.current.files.length === 1){
			let formData = new FormData();
				formData.append("file", refPhoto.current.files[0]);
				formData.append("facilityId", id);
			
				functions.submitAjax("/resolution/voyansiuploadfacilityphoto", 
					formData, submitPlan, NO_STRINGIFY, handleSubmitError);
		}
		else{
			submitPlan();
		}
	};
	
	const submitPlan = () => {
		if(refPlan.current.files && refPlan.current.files.length === 1){
			let formData = new FormData();
				formData.append("file", refPlan.current.files[0]);
				formData.append("facilityId", id);
			
				functions.submitAjax("/resolution/voyansiuploadfacilityplan", 
					formData, saveEnd, NO_STRINGIFY, handleSubmitError);
		}
		else{
			saveEnd();
		}
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/facilitydelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};
	
	const relatedDataPanel = {
		display:"flex",
		width:"calc(50% - 50px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		flexDirection:"column",
		minHeight:"100px",
		marginLeft:"30px"
	};
	
	const titlePanel = {
		display:'flex',
		width:"100%",
		alignItems:"center",
		justifyContent:"space-around",
		color:"black",
		height:"40px",
		fontSize:"14px",
		fontWeight:"bold"
	};
	
	const editRow = {
		display:"flex",
		minHeight:"40px",
		alignItems:"center"
	};
	
	const editTitle = {
		display:"flex",
		width:"150px",
		fontSize:"12px",
		paddingLeft:"20px"
	};
	
	const getClassificationRestUrl = (classificationId) => {
		return "classificationitemsforclassification?classificationId=" + classificationId;
	};
	
	const classificationDisplay = classifications.map((item, index) => 
		<div style={editRow}>
			<div style={editTitle}>
				{item.name}
			</div>
			<EditPanelInputSelectFromDb thisRef={(element) => refClassifications.current.push(element)} restUrl={getClassificationRestUrl(item.id)} noSearch="Y"/>
		</div>
	);
	
	const photoEditRow = {
		display:"flex",
		marginTop:"10px",
		marginLeft:"10px",
		marginBottom:"10px"
	};
	
	const photoContainer = {
		display:"flex",
		width:"150px",
		height:"80px",
		border:"1px solid darkgrey",
		color:"black",
		fontSize:"12px",
		justifyContent:"space-around",
		alignItems:"center",
		marginRight:"10px"
	};
	
	const photoStyle = {
		display:"flex",
		width:"100%"
	};
	
	const getPhotoDisplay = () => {
		if(photoName != ""){
			return <img src={photoSource} style={photoStyle}/>;
		}
		else{
				return "no image uploaded";
		}
	
	};
	
	const getPlanDisplay = () => {
		
		if(planName && planName != ""){
			return <img src={planSource} style={photoStyle}/>;
		}
		else{
				return "no plan uploaded";
		}
	
	};
	
	const photoInput = {
		display:"flex",
		width:"200px",
		height:"30px"
	};
	
	const hideProgress = () => {
		setDisplayProgress("none");
	};
	
	const goUploadPopup = () => {
		setDisplayUploadPopup("flex");
	};
	
	const uploadEnd = () => {
		alert("Upload Success");
		setDisplayProgress("none");
	};
	
	const handleSubmitUploadError = () => {
		alert("Upload Success");
		setDisplayProgress("none");
	};
	
	const goUpload = () => {
		setDisplayUploadPopup("none");
		setDisplayProgress("flex");
		
		let formData = new FormData();
			formData.append("file", uploadFileInput.current.files[0]);
			formData.append("facilityId", id);
			formData.append("isModel", isModel);
			functions.submitAjax("/resolution/uploadsimpleresource", 
				formData, uploadEnd, NO_STRINGIFY, handleSubmitUploadError);
	};
	
	const buttonContainer = {
		display:"flex",
		marginRight:"20px"
	};
	
	const menuButton = {
		display:"flex",
		height:"30px",
		width:"150px",
		backgroundColor:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		color:"white",
		fontSize:"14px",
		cursor:"pointer",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
		borderRadius:"4px",
		marginLeft:"5px"
	};
	
	const progressContainer = {
		display:displayProgress,
		width:"100%",
		height:"calc(100vh - 0px)",
		backgroundColor:"white",
		flexDirection:"column",
		zIndex:"2000",
		color:DEFAULT_BLUE,
		alignItems:"center",
		justifyContent:"space-around",
		position:"fixed",
		top:"0px",
		left:"0px"
	};
	
	
	const uploadPopup = {
		display:displayUploadPopup,
		position:"fixed",
		top:"130px",
		right:"20px",
		width:"500px",
		backgroundColor:"white",
		minHeight:"50px",
		flexDirection:"column",
		boxShadow: '0 6px 3px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)'
	};
	
	const uploadTitle = {
		display:"flex",
		height:"40px",
		alignItems:"center",
		marginLeft:"20px",
		fontSize:"14px",
		color:"black"
	};
	
	const fileInput = {
		display:"flex",
		marginLeft:"20px"
	};
	
	const buttonBar = {
		display:"flex",
		alignSelf:"center",
		margin:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"110px",
		backgroundColor:DEFAULT_BLUE,
		color:"white",
		height:"20px",
		fontSize:"12px",
		alignItems:"center",
		justifyContent:"space-around",
		borderRadius:"4px",
		cursor:"pointer",
		margin:"3px"
	};
	
	const goCancelUpload = () => {
		setDisplayUploadPopup("none");
	};
	
	const inputRow = {
		display:"flex",
		height:"40px",
		alignItems:"center",
		fontSize:"12px"
	};
	
	const modelCheck = {
		display:"flex"
	};
	
	const handleCheckBoxClick = () => {
		if(isModel === 0){
			setIsModel(1);
		}
		else{
			setIsModel(0);
		}
	};

	const getAdminFloorsDisplay = () => {
		if(isSuperAdmin() === true){
			return 	<AdminFloors
								buildingId={id}
								buildingName={entityName}
								isSite={isSite}
			/>;
		}
		else{
			return <div/>
		}
	};
	
	const getAdminSitePlanDisplay = () => {
		if(isSuperAdmin() === true){
			return <div style={photoEditRow}>
				<div style={photoContainer}>
					{getPlanDisplay()}
				</div>
				<input type="file" ref={refPlan} style={photoInput}/>
			</div>;
		}
		else{
			return <div style={{...photoEditRow, display:'none'}}>
				<div style={photoContainer}>
					{getPlanDisplay()}
				</div>
				<input type="file" ref={refPlan} style={photoInput}/>
			</div>;
		}
	};
	
	const getAdminScanUrlDisplay = () => {
		if(isSuperAdmin() === true){
			return <div style={editRow}>
					<div style={editTitle}>
						Scan Viewer Url (e.g. Benaco)
					</div>
					<EditPanelInputText thisRef={refAtisUrl}/>
				</div>;
		}
		else{
			return <div style={{...editRow, display:'none'}}>
					<div style={editTitle}>
						Scan Viewer Url (e.g. Benaco)
					</div>
					<EditPanelInputText thisRef={refAtisUrl}/>
				</div>;
		}
	};
	
	const getModelCheckDisplay = () => {
		if(isSuperAdmin() === true){
			return 	<div><input type="checkbox" ref={uploadFileModelCheck} style={modelCheck} onClick={handleCheckBoxClick}/>
							Set as primary RVT model</div>
		}
		else{
			return <div/>
		}
	}

	return (
	
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
				<div style={administrationHeader}>
					Property Edit: {entityName}
					<div style={buttonContainer}>
						<div style={menuButton} onClick={goUploadPopup}>
							Upload Resource
						</div>
					</div>
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					<div style={relatedDataPanel}>
						<div style={titlePanel}>
							Classifications & Related Data
						</div>
						{classificationDisplay}
						
						{getAdminScanUrlDisplay()}
						{getAdminFloorsDisplay()}
						<div style={photoEditRow}>
							<div style={photoContainer}>
								{getPhotoDisplay()}
							</div>
							<input type="file" ref={refPhoto} style={photoInput}/>
						</div>
						{getAdminSitePlanDisplay()}
					</div>
				</div>
					<div style={progressContainer}>
					<CircularProgress
							color="inherit"
						>
						</CircularProgress>
				</div>
				<div style={uploadPopup}>
					<div style={uploadTitle}>
						Upload a resource:
					</div>
					<div style={inputRow}>
							<input type="file" style={fileInput} ref={uploadFileInput}/>
							{getModelCheckDisplay()}
					</div>
				
					<div style={buttonBar}>
						<div style={blueButton} onClick={goUpload}>
							Upload
						</div>
						<div style={blueButton} onClick={goCancelUpload}>
							Cancel
						</div>
					</div>
				</div>
				<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="facilities"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
			</div>
	
	);
}